import { render, staticRenderFns } from "./DomainStatusList.vue?vue&type=template&id=07b6a2d8&"
import script from "./DomainStatusList.vue?vue&type=script&lang=js&"
export * from "./DomainStatusList.vue?vue&type=script&lang=js&"
import style0 from "./DomainStatusList.vue?vue&type=style&index=0&id=07b6a2d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports